const CheckboxIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="#E6F0F4" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#006694" />
      <path
        d="M14.6663 6.5L8.24967 12.9167L5.33301 10"
        stroke="#006694"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckboxIcon;
